import {useDimensions} from 'react-native-responsive-ui/src/index'
import {useMemo} from 'react'

const useStyles = (createStyles) => {
    const {width, height, scale, fontScale} = useDimensions()
    return useMemo(() => createStyles({width, height, scale, fontScale}), [width, height, scale, fontScale])
}

export default useStyles
